module.exports = __webpack_public_path__ + "assets/5b9cbc53021fc08fc68580c0a45c36bc.json";